import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reactivateUser } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';
import type { AdminUser } from '../types/users.types';

export const useReactivateUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, string>({
        mutationFn: (id) => reactivateUser(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
